module.exports = __webpack_public_path__ + "img/grid-maxwidth.c1ccffb9.png";